import * as React from 'react';
import classnames from 'classnames';
import { useIntl } from '@grandvisionhq/state';
import { formatPrice } from '@grandvisionhq/utils';

const BestPrice = ({ bestPriceAmount , currencyCode , className , isCentAmount =false , isFeatureEnabled , discountedPrice , originalPrice  })=>{
    const { getFormattedLabel , locale  } = useIntl();
    if (!isFeatureEnabled || !bestPriceAmount) {
        return null;
    }
    /*
    Show recent lowest price only if:
      1. The feature is enabled
      2. The (product) variant has a defined product attribute bestPrice
      3. The bestPrice is different from the discounted price if there is a discounted price
      4. The bestPrice is different from the product original price if there is no discounted price
  */ const shouldShowBestPrice = isFeatureEnabled && bestPriceAmount && (discountedPrice && bestPriceAmount !== discountedPrice || !discountedPrice && bestPriceAmount !== originalPrice);
    if (!shouldShowBestPrice) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        "data-t": "best-price",
        className: classnames('best-price', className)
    }, getFormattedLabel('products.recentLowestPrice', {
        labelData: {
            recentLowestPrice: formatPrice({
                locale,
                value: bestPriceAmount,
                currency: currencyCode,
                isCentAmount
            })
        }
    }));
};

export { BestPrice };
//# sourceMappingURL=BestPrice.js.map
